import { useState, useContext, useEffect, createContext, ReactNode } from "react";

type Language = "fr" | "en";
type LangContextType = {
  lang: Language;
  setLang: (l: Language) => void;
};
const LanguageContext = createContext<LangContextType | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [lang, setLang] = useState<Language>(() => {
    try {
      const saved = window.localStorage.getItem("lang");
      return saved === "fr" || saved === "en" ? saved : "fr";
    } catch {
      return "fr";
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("lang", lang);
    } catch {
      // stockage indisponible : on ignore silencieusement
    }
  }, [lang]);

  return <LanguageContext.Provider value={{ lang, setLang }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = (): LangContextType => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within a LanguageProvider");
  return context;
};
